/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/templates/product/related-products.js":
/*!***********************************************************!*\
  !*** ./zrc/scripts/templates/product/related-products.js ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @shopify/theme-sections */ \"./node_modules/@shopify/theme-sections/theme-sections.js\");\n/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! swiper */ \"./node_modules/swiper/swiper.esm.js\");\n/* harmony import */ var _helpers_set_height_elements_v2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helpers/set-height-elements-v2 */ \"./zrc/scripts/helpers/set-height-elements-v2.js\");\n\n\n\nclass RebuyRelatedProducts extends window.HTMLElement {\n  constructor() {\n    super();\n    this.init();\n  }\n  init() {\n    this.slider = this.querySelector('.related-products-widget--slider');\n    this.nextButton = this.querySelector('.related-products-widget-arrow.next');\n    this.prevButton = this.querySelector('.related-products-widget-arrow.prev');\n    this.initSlider();\n    this.textAlignment();\n  }\n  initSlider() {\n    // Función para inicilizar el slider de swatches\n    // swiper es mobile first\n\n    var carouselConfig = {\n      modules: [swiper__WEBPACK_IMPORTED_MODULE_1__.Navigation],\n      loop: false,\n      slidesPerView: 2,\n      slidesPerGroup: 2,\n      spaceBetween: 7,\n      navigation: {\n        prevEl: this.prevButton,\n        nextEl: this.nextButton\n      },\n      breakpoints: {\n        681: {\n          slidesPerView: 2,\n          slidesPerGroup: 2,\n          spaceBetween: 14\n        },\n        1000: {\n          slidesPerView: 3,\n          slidesPerGroup: 3,\n          spaceBetween: 14\n        },\n        1384: {\n          slidesPerView: 4,\n          slidesPerGroup: 4,\n          spaceBetween: 19\n        }\n      }\n    };\n    this.slider = new swiper__WEBPACK_IMPORTED_MODULE_1__.default(this.slider, carouselConfig);\n  }\n  textAlignment() {\n    // Seleccionamos todos los wrappers que necesitamos\n    var $titles = this.querySelectorAll(\".product-card-title\");\n    var $stars = this.querySelectorAll(\".product-card-stars\");\n    var $prices = this.querySelectorAll(\".product-card-price\");\n    var $subscriptions = this.querySelectorAll(\".product-card-subscriptions\");\n\n    // configuracion del componente\n    var options = {\n      cssVariable: \"--min-height\"\n    };\n\n    // inicializamos la alineacion\n    this.titlesCalculation = new _helpers_set_height_elements_v2__WEBPACK_IMPORTED_MODULE_2__.ElementsHeightCalculation($titles, options);\n    this.starsCalculation = new _helpers_set_height_elements_v2__WEBPACK_IMPORTED_MODULE_2__.ElementsHeightCalculation($stars, options);\n    this.pricesCalculation = new _helpers_set_height_elements_v2__WEBPACK_IMPORTED_MODULE_2__.ElementsHeightCalculation($prices, options);\n    this.subscriptionsCalculation = new _helpers_set_height_elements_v2__WEBPACK_IMPORTED_MODULE_2__.ElementsHeightCalculation($subscriptions, options);\n    $subscriptions.forEach($subscription => {\n      var observer = new window.MutationObserver(() => {\n        this.subscriptionsCalculation.refresh();\n      });\n      observer.observe($subscription, {\n        childList: true,\n        subtree: true\n      });\n    });\n  }\n}\nwindow.customElements.define('rebuy-related-products', RebuyRelatedProducts);\nvar sectionType = 'product-related-products-section';\nvar sectionConfig = {\n  onLoad() {\n    var $widget = this.container.querySelector('#product-related-products-widget');\n\n    // Estos eventos se declaran en la app de rebuy dentro de los custom callbacks del widget\n    $widget.addEventListener('custom::ready', () => {\n      var $related = this.container.querySelector('rebuy-related-products');\n      $related.init();\n      // window.customElements.define('rebuy-related-products', RebuyRelatedProducts);\n    });\n  }\n};\n\n// Se determina si ya se ha registrado la seccióno no.\nif (_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__.registered[sectionType] == null) {\n  (0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__.register)(sectionType, sectionConfig);\n}\n\n// Debido a que esta seccion tambien se encuentra en la PDP\n// ponemos el listener para que recarge la seccion cuando se cambia de producto con el Product linking\ndocument.addEventListener('update::product_linking', () => {\n  (0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__.unregister)(sectionType);\n  (0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__.register)(sectionType, sectionConfig);\n  (0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__.load)(sectionType);\n});\n\n//# sourceURL=webpack://getmore-workflow/./zrc/scripts/templates/product/related-products.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// the startup function
/******/ 	// It's empty as some runtime module handles the default behavior
/******/ 	__webpack_require__.x = x => {};
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// Promise = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"product-related-products": 0
/******/ 		};
/******/ 		
/******/ 		var deferredModules = [
/******/ 			["./zrc/scripts/templates/product/related-products.js","commons"]
/******/ 		];
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		var checkDeferredModules = x => {};
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime, executeModules] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0, resolves = [];
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					resolves.push(installedChunks[chunkId][0]);
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			while(resolves.length) {
/******/ 				resolves.shift()();
/******/ 			}
/******/ 		
/******/ 			// add entry modules from loaded chunk to deferred list
/******/ 			if(executeModules) deferredModules.push.apply(deferredModules, executeModules);
/******/ 		
/******/ 			// run deferred modules when all chunks ready
/******/ 			return checkDeferredModules();
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkgetmore_workflow"] = self["webpackChunkgetmore_workflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 		
/******/ 		function checkDeferredModulesImpl() {
/******/ 			var result;
/******/ 			for(var i = 0; i < deferredModules.length; i++) {
/******/ 				var deferredModule = deferredModules[i];
/******/ 				var fulfilled = true;
/******/ 				for(var j = 1; j < deferredModule.length; j++) {
/******/ 					var depId = deferredModule[j];
/******/ 					if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferredModules.splice(i--, 1);
/******/ 					result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 				}
/******/ 			}
/******/ 			if(deferredModules.length === 0) {
/******/ 				__webpack_require__.x();
/******/ 				__webpack_require__.x = x => {};
/******/ 			}
/******/ 			return result;
/******/ 		}
/******/ 		var startup = __webpack_require__.x;
/******/ 		__webpack_require__.x = () => {
/******/ 			// reset startup function so it can be called again when more startup code is added
/******/ 			__webpack_require__.x = startup || (x => {});
/******/ 			return (checkDeferredModules = checkDeferredModulesImpl)();
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// run startup
/******/ 	__webpack_require__.x();
/******/ })()
;